var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofingFacade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6251 40.4384H40.9751V49.0884H49.6251V40.4384Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6951 49.0884V40.4384H21.3851V49.0884H38.6951Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0451 29.4984H15.0251C14.1751 30.9684 13.4051 32.4884 12.7351 34.0584V38.1484H30.0451V29.4984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3251 29.4984V38.1584H49.6351V29.4984H32.3251Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6151 40.4384C9.93515 43.2284 9.54515 46.1184 9.46515 49.0884H19.1151V40.4384H10.6151Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6251 18.5684H40.9751V27.2184H49.6251V18.5684Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6951 18.5684H24.2351C23.2451 19.3984 22.2951 20.2684 21.3851 21.1884V27.2184H38.6951V18.5684Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1051 23.6884C18.1551 24.8184 17.2651 25.9884 16.4451 27.2184H19.1051V23.6884Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0451 14.4884C29.0751 15.0484 28.1351 15.6484 27.2251 16.2884H30.0451V14.4884Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3251 16.2884H49.6351V8.93841C43.4251 9.10841 37.5551 10.6484 32.3251 13.2584V16.2884Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9751 90.4084C43.7651 91.0884 46.6551 91.4784 49.6251 91.5584V84.1684H40.9751V90.4084Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6951 89.7784V84.1684H27.1651C30.6551 86.5984 34.5351 88.5084 38.6951 89.7784Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6351 73.2384H32.3251V81.8884H49.6351V73.2384Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0451 73.2384H16.4251C18.5951 76.4784 21.2151 79.3884 24.1951 81.8884H30.0451V73.2384Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6251 62.2984H40.9751V70.9484H49.6251V62.2984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6951 70.9584V62.2984H21.3851V70.9584H38.6951Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1051 62.2984H11.2251C12.1551 65.3484 13.4251 68.2484 14.9951 70.9484H19.1051V62.2984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7351 51.3684V60.0184H30.0451V51.3684H12.7351Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6351 51.3684H32.3251V60.0184H49.6351V51.3684Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7351 50.1084C88.7451 49.9184 90.5651 49.1084 92.0251 47.8784C91.9851 47.0784 91.9151 46.2784 91.8251 45.4884C90.3951 47.2184 88.2351 48.3184 85.8151 48.3184C81.5151 48.3184 78.0151 44.8184 78.0151 40.5184V36.6884C81.4651 36.3584 84.3951 34.1984 85.8151 31.1984C86.5751 32.8084 87.7651 34.1784 89.2451 35.1484C88.1051 32.2384 86.6351 29.4884 84.8951 26.9484V27.0984C84.8951 31.3984 81.3951 34.8984 77.0951 34.8984C72.7951 34.8984 69.2952 31.3984 69.2952 27.0984V23.2684C72.5751 22.9584 75.3851 20.9884 76.8652 18.2184C76.3851 17.8284 75.8951 17.4384 75.3951 17.0684C74.1252 19.6684 71.4551 21.4684 68.3751 21.4684C64.0751 21.4684 60.5751 17.9684 60.5751 13.6684V10.0984C59.9651 9.94841 59.3551 9.81841 58.7351 9.69841V13.6684C58.7351 17.6384 55.7451 20.9284 51.8951 21.4084V23.2584C55.3251 22.9184 58.2351 20.7584 59.6451 17.7684C61.0651 20.7784 63.9951 22.9284 67.4451 23.2584V27.0884C67.4451 31.3884 63.9451 34.8884 59.6451 34.8884C55.6351 34.8884 52.3151 31.8484 51.8951 27.9484V32.8084C53.4752 34.9484 55.9352 36.4184 58.7351 36.6884V40.5184C58.7351 44.4884 55.7451 47.7784 51.8951 48.2584V50.1084C55.3251 49.7684 58.2351 47.6084 59.6451 44.6184C61.0651 47.6284 63.9951 49.7784 67.4451 50.1084V53.9384C67.4451 58.2384 63.9451 61.7384 59.6451 61.7384C55.6351 61.7384 52.3151 58.6984 51.8951 54.7984V59.6584C53.4752 61.8084 55.9352 63.2684 58.7351 63.5384V67.3684C58.7351 71.3384 55.7451 74.6284 51.8951 75.1084V76.9584C55.3251 76.6184 58.2351 74.4584 59.6451 71.4684C61.0651 74.4784 63.9951 76.6284 67.4451 76.9584V80.6884C67.4451 84.9884 63.9451 88.4884 59.6451 88.4884C55.6351 88.4884 52.3151 85.4484 51.8951 81.5484V86.4084C53.6551 88.7884 56.4752 90.3284 59.6451 90.3284C60.4151 90.3284 61.1651 90.2384 61.8751 90.0684C62.1852 89.9984 62.4851 89.9084 62.7851 89.8084C65.2451 88.9584 67.2652 87.1284 68.3652 84.7984C68.7352 85.5884 69.2051 86.3084 69.7651 86.9584C70.3251 86.6684 70.8751 86.3684 71.4151 86.0484C70.0951 84.6484 69.2751 82.7584 69.2751 80.6884V76.9584C72.7251 76.6284 75.6552 74.4684 77.0751 71.4684C78.1852 73.8084 80.2051 75.6384 82.6852 76.4884C83.1051 75.9784 83.5051 75.4684 83.9052 74.9384C80.5152 74.0884 78.0051 71.0184 78.0051 67.3684V63.5384C81.4551 63.2084 84.3851 61.0484 85.8051 58.0484C86.7251 60.0084 88.2952 61.5984 90.2252 62.5684C90.4052 61.9784 90.5851 61.3784 90.7451 60.7684C88.3551 59.4384 86.7351 56.8784 86.7351 53.9484V50.1084ZM60.5851 40.5084V36.6784C64.0351 36.3484 66.9651 34.1884 68.3851 31.1884C69.8051 34.1984 72.7352 36.3484 76.1852 36.6784V40.5084C76.1852 44.8084 72.6852 48.3084 68.3851 48.3084C64.0851 48.3084 60.5851 44.8084 60.5851 40.5084ZM76.1852 67.3584C76.1852 71.6584 72.6852 75.1584 68.3851 75.1584C64.0851 75.1584 60.5851 71.6584 60.5851 67.3584V63.5284C64.0351 63.1984 66.9651 61.0384 68.3851 58.0384C69.8051 61.0484 72.7352 63.1984 76.1852 63.5284V67.3584ZM84.8951 53.9384C84.8951 58.2384 81.3951 61.7384 77.0951 61.7384C72.7951 61.7384 69.2952 58.2384 69.2952 53.9384V50.1084C72.7451 49.7784 75.6751 47.6184 77.0951 44.6184C78.5151 47.6284 81.4452 49.7784 84.8951 50.1084V53.9384Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1686",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1686",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1686",
    result: "effect3_innerShadow_4857_1686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofingFacade);
export default __webpack_public_path__ + "static/media/RoofingFacade.b3a22e8c4a7769159985e4da732957c9.svg";
export { ForwardRef as ReactComponent };